import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from 'app/core/models/capture.model';
import { ClientPrescriptionMatch } from 'app/core/models/client-prescription-match.model';
import { PrescriptionsService } from 'app/core/services/prescriptions.service';
import { ClientPrescriptionMatchKind } from 'app/core/enums/client-prescription-match-kind.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { NgClass, DatePipe } from '@angular/common';
import { ClientPrescriptionMatchKindNamePipe } from '../../../shared/pipes/client-prescription-match-kind-name.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

class ClientPrescriptionMatchOption {
  match: ClientPrescriptionMatch;
  bestMatch: boolean;
}

@Component({
  selector: 'app-client-prescription-matches',
  templateUrl: './client-prescription-matches.component.html',
  styleUrls: ['./client-prescription-matches.component.scss'],
  imports: [NgClass, DatePipe, ClientPrescriptionMatchKindNamePipe, BlankValueDashPipe]
})
export class ClientPrescriptionMatchesComponent implements OnInit {
  private prescriptionsService = inject(PrescriptionsService);

  @Input() capture: Capture;

  static readonly clientPrescriptionMatchKindRank = {
    [ClientPrescriptionMatchKind.cePrescriber]: 1,
    [ClientPrescriptionMatchKind.internalReferral]: 2
  };

  claimPrescriptionDrugDescriptions: string;
  claimPrescriptionDrugNdcs: string;
  clientPrescriptionMatchOptions: ClientPrescriptionMatchOption[] = [];

  ngOnInit() {
    const prescription = this.capture.prescription;

    this.claimPrescriptionDrugDescriptions = prescription.drugs.map(drug => drug.description).join(', ');
    this.claimPrescriptionDrugNdcs = prescription.drugs.map(drug => drug.ndc).join(', ');

    this.getClientPrescriptionMatches();
  }

  private getClientPrescriptionMatches() {
    this.prescriptionsService.getClientPrescriptionMatches(this.capture.prescription).subscribe(
      result => {
        this.clientPrescriptionMatchOptions =
          this.prepareClientPrescriptionMatchOptions(result.clientPrescriptionMatches);
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  private prepareClientPrescriptionMatchOptions(clientPrescriptionMatches: ClientPrescriptionMatch[]) {
    const options =
      clientPrescriptionMatches.
        sort(this.clientPrescriptionMatchSort).
        map(this.newClientPrescriptionMatchOption);

    if (options[0]) {
      options[0].bestMatch = true
    }

    return options;
  }

  private newClientPrescriptionMatchOption(match: ClientPrescriptionMatch) {
    const option = new ClientPrescriptionMatchOption;
    option.match = match;
    return option;
  }

  private clientPrescriptionMatchSort(clientPrescriptionMatch1, clientPrescriptionMatch2) {
    return ClientPrescriptionMatchesComponent.clientPrescriptionMatchKindRank[clientPrescriptionMatch1.kind] -
           ClientPrescriptionMatchesComponent.clientPrescriptionMatchKindRank[clientPrescriptionMatch2.kind];
  }
}
